import OrientationInstructionPlayer from './OrientationInstructionPlayer';

export default class VideoPlayer {
    constructor(testElement, environment, uiService) {
        this.signal;
        this.testElements = [];
        this.testElement = testElement;
        this.isStarted = false;
        this.displayTimeout;
        this.isPreloaded = false;
        this.isActive = false;
        this.failed = false;
        this.preloadFinishedCallback = null;
        this.environment = environment;

        this.videoElement = document.createElement('video');
        this.videoElement.muted = 'muted';
        this.videoElement.autoplay = false;
        this.videoElement.playsInline = true; //NOTE: <video autoplay="false" muted="muted" playsinline></video>
        this.videoElement.preload = 'auto';
        this.videoElement.style.display = 'none';

        this.videoArticle = document.getElementById('VideoPlayer');
        this.videoArticle.appendChild(this.videoElement);

        this.orientationInstructionPlayer = new OrientationInstructionPlayer(environment);
        this.uiService = uiService;

        this._setVideoEventHandlers();
    }

    _setVideoEventHandlers() {
        this.videoElement.addEventListener('ended', () => {
            this._endCurrentTestElement();
        });

        this.videoElement.addEventListener('contextmenu', (e) => {
            e.preventDefault();
        });
    }

    async preload(needPreload) {
        if (!needPreload || (this.environment.browserName == "safari")) {
            this.isPreloaded = true;
            this.videoElement.src = this.testElement.secureURL;

            return;
        }

        try {
            const response = await fetch(this.testElement.secureURL, {
                mode: 'cors'
            });

            const videoData = await response.blob();
            this.testElement.videoUrl = URL.createObjectURL(videoData);
            this.isPreloaded = true;
            this.videoElement.src = this.testElement.videoUrl;
        } catch (e) {
            //CORS issue blocks this kind of preload
            this.videoElement.src = this.testElement.secureURL;
            this.isPreloaded = true;
        }
    }

    async initPlayer() {
        //Iphone hack or something like this play then stop
        await this.videoElement.play();
        this.stop();
        this.videoElement.currentTime = 0;
    }

    start() {
        return new Promise(async (resolve) => {
            this.signal = resolve;

            this.isSkipped = false;
            this.isPreloaded = true;
            this.isStarted = true;

            if (this.orientationInstructionPlayer.isActive) {
                setTimeout(async () => {
                    this.orientationInstructionPlayer.stop();
                    this.isActive = true;
                    this._showVideoArticle();
                    await this._startVideo();
                }, 3000);
            } else {
                await this._startVideo();
            }
        });
    }

    async _startVideo() {
        if ((window.jsModuleSettings || {}).disableSound === 'true') {
            this.setVolume(0);
        } else {
            this.setVolume(1);
        }
        await this.play();

        if (this.testElement.cutoffTime && this.testElement.cutoffTime > 0 && !this.displayTimeout) {
            this.displayTimeout = setTimeout(() => {
                this.stop();
                this._endCurrentTestElement();
            }, this.testElement.cutoffTime);
        }
    }

    skip() {
        this.isSkipped = true;
        this.skippedTime = this.getCurrentTime();
        this.stop();
        this._endCurrentTestElement();
    }

    onLoaded(clbck) {
        this.preloadFinishedCallback = clbck;
    }

    //NOTE: This needs only for the dumb ResultCollector startpooling
    onStateChange(clbck) { }

    getPosition() {
        return {
            elementId: this.testElement.testElementSequenceID,
            position: this.videoElement.currentTime * 1000
        };
    }

    close() {
        if (this.isStarted) {
            this.stop();
        }

        this.videoElement.remove();
        this.hide();
    }

    _endCurrentTestElement() {
        if (this.testElement.cutoffTime && this.testElement.cutoffTime > 0 && this.displayTimeout) {
            clearTimeout(this.displayTimeout);
        }

        this.signal();
    }

    // todo: move it to UI logic
    show() {
        if (window.jsModuleSettings.orientationInstructionEnabled === 'true') {
            this._showOrientationInstruction();
        } else {
            this._showVideoArticle();
        }
    }

    _showVideoArticle() {
        this.uiService.switchScreen('#VideoPlayer');

        this.videoElement.style.display = '';
    }

    _showOrientationInstruction() {
        this.orientationInstructionPlayer.start(this.testElement);

        if (this.orientationInstructionPlayer.isActive) {
            this.isActive = false;
        } else {
            this._showVideoArticle();
        }
    }

    // todo: move it to UI logic
    hide() {
        this.videoElement.style.display = 'none';
    }

    async play() {
        this.uiService.switchScreen('#VideoPlayer');
        await this.videoElement.play();
        this.videoElement.muted = false;
    }

    stop() {
        this.videoElement.pause();
    }

    setVolume(level) {
        this.videoElement.volume = level;
    }
}
